export enum ETipoMovimientoKardex {
  INGRESO = 'INGRESO',
  EGRESO = 'EGRESO',
  COMPRA = 'COMPRA',
  VENTA = 'VENTA',
  DEVOLUCION = 'DEVOLUCION',
  SALIDA_RECETA = 'SALIDA_RECETA',
}
